import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DeviceFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetAll(catDetTypeId: number, language: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Device/ByTypeId?typeId=' + catDetTypeId + '&&language=' + language);
  }

  Create(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.post(this._urlBase + 'api/Device/', body, {
        headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

  Update(parameters: any): Observable<any> {
    const body = JSON.stringify(parameters);
    return this._httpClient.put(this._urlBase + 'api/Device/', body, {
        headers: new HttpHeaders({'Content-Type':  'application/json'})
    });
  }

  GetByStore(storeId: number, language: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/Device?assignedStoreId=' + storeId + '&&language=' + language);
  }

}
